import { Box, Link, Button } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'
import LinkIcon from '@mui/icons-material/Link';
import DiscordIcon from '@images/icon_discord.svg'
import './Layout.scss'

const Footer = () => {
  return (
    <Box
      className="footer"
    >
      <Box
        className="top"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center", px: 3 }}
      >
        <Link
          href="https://discord.gg/VZ43BwhfrE"
          underline="none"
          target="_blank"
        >
          <Button
            className="btn-purple font-bold"
            sx={{ py: 3, px: 10 }}
          >
            <img src={DiscordIcon} alt="icon discord" style={{ marginRight: "10px" }} />
            Join Our Discord
          </Button>
        </Link>
        <Link
          href="https://docs.presail.club/"
          underline="none"
          target="_blank"
        >
          <Button
            className="btn-outlined font-bold"
            startIcon={<HelpOutline />}
            sx={{ py: 3, px: 10, ml: 3 }}
          >
            Documentation
          </Button>
        </Link>
        <Link
          href="https://www.presail.club/"
          underline="none"
          target="_blank"
        >
          <Button
            className="btn-white font-bold"
            startIcon={<LinkIcon />}
            sx={{ py: 3, px: 10, ml: 3 }}
          >
            Presail.club
          </Button>
        </Link>
      </Box>
      {/* <Box
                className="bottom"
            >
                <Grid
                    container
                    alignItems="center"
                    spacing={2}
                >
                    <Grid
                        item
                        xs={12}
                        sm={3}
                    >
                        <Link
                            className="logo"
                            href="/"
                        >
                            <img src={LogoIcon} alt="logo icon" />
                        </Link>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        className="font-sm"
                    >
                        LaunchPools is a Maxos.Studio venture. <br/>
                        Copyright ©2021 MAXOS, LLC
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={3}
                    >
                    </Grid>
                </Grid>
            </Box> */}
    </Box>
  )
}

export default Footer